import { Card } from '@/components/ui/card';

const AdminSEO = () => (
  <Card className="p-6 text-center">
    <h1 className="text-xl font-semibold mb-2">SEO Manager Disabled</h1>
    <p className="text-muted-foreground">Per-page SEO is handled automatically via page metadata.</p>
  </Card>
);
export default AdminSEO;
